import DrillDownFilterDrawer from './DrillDownFilterDrawer'
import {
  DrillDownFilterDesktop,
  DrillDownFilterMobile,
  DrillDownFilterPlatform,
} from './DrillDownFilterPlatform'
import DrillDownFilterPopover from './DrillDownFilterPopover'

const DrillDownFilter = {
  Popover: DrillDownFilterPopover,
  Drawer: DrillDownFilterDrawer,
  Platform: DrillDownFilterPlatform,
  Mobile: DrillDownFilterMobile,
  Desktop: DrillDownFilterDesktop,
}

export default DrillDownFilter
